export default __webpack_public_path__ + "static/media/Group12134.607b25de.png";